import script from "./TextViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./TextViewer.vue?vue&type=script&setup=true&lang=js"

import "./TextViewer.vue?vue&type=style&index=0&id=5efe7b3d&lang=sass"

const __exports__ = script;

export default __exports__